import { render, staticRenderFns } from "./OrderStatusDropdown.vue?vue&type=template&id=42ac53f7&"
import script from "./OrderStatusDropdown.vue?vue&type=script&lang=js&"
export * from "./OrderStatusDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports